import { css } from 'styled-components';
import {
  getSpacing, SpacingName, TypographyName, getTypography, ThemedFunctor, rgba, ellipsis,
} from '@doveit/lego';

export const basic: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.BODY)}
  position: relative;
  overflow: hidden;
`;

export const title: ThemedFunctor = () => css`
  ${ellipsis()}
`;

export const saving: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.H4)}
  ${getSpacing.marginBottom(theme, SpacingName.SMALL)}
  font-weight: 700;

  > strong {
    color: ${theme.palettes.brand.primary}
  }
`;

export const imageWrapper = css`
  position: relative;
`;

export const banner: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.BODY)}
  text-align: center;
  background-color: ${rgba(theme.palettes.brand.primary, 0.8)};
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  padding: 1rem;
  transform: translateY(-50%);
  color: ${theme.palettes.neutrals.lightest};
  text-transform: uppercase;
  z-index: 2;
  pointer-events: none;
`;

export const image = css`
  position: relative;
  z-index: 1;
`;
